// eslint-disable-next-line no-unused-vars
export default (element, data) => {
  const init = () => {
    const seoText = document.querySelector('[data-seo-text]');
    const seoTextTruncated = document.querySelector('[data-seo-text-truncated');
    seoTextTruncated?.addEventListener('click', () => {
      seoTextTruncated.classList.add('hidden');
      seoText.classList.remove('hidden');
    })
  };

  init();
};
